/* eslint-disable max-len */
import React from "react";
import { number, object } from "prop-types";

const VigilWhiteLogo = ({ width = 85, height = 30, member }) => (
  <svg width={width} height={height} viewBox="0 0 602 203" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M120.73 24.0293H149.22L104.07 192.059C102.71 197.109 98.63 200.839 93.67 201.899H41.19L0 24.0293H38.84L73.74 174.729H80.24L120.73 24.0293Z"
      fill="white"
    />
    <path d="M173.21 201.721V79.8906H211.1V201.721H173.21Z" fill="white" />
    <path
      d="M408.41 128.139V141.899H403.31C391.21 176.669 358.18 201.729 319.34 201.729C270.28 201.729 230.37 161.819 230.37 112.759C230.37 63.6991 270.28 23.7891 319.34 23.7891C361.74 23.7891 397.28 53.6091 406.16 93.3791H365.09V83.2991C365.09 58.0291 344.61 37.5491 319.34 37.5491C294.07 37.5491 273.59 58.0291 273.59 83.2991V142.449C273.59 167.719 294.07 188.199 319.34 188.199C344.61 188.199 365.09 167.719 365.09 142.449V141.909H333.95V128.149H408.41V128.139Z"
      fill="white"
    />
    <path d="M421.73 201.719V23.7793H459.62V201.719H421.73Z" fill="white" />
    <path d="M601.94 188.35V202.11H481.14V202H481.02V24H518.86V188.36H601.94V188.35Z" fill="white" />
    <path
      d="M225.06 39.48H208.03L220.07 51.52L210.77 60.82L198.73 48.78V65.81H185.58V48.78L173.54 60.82L164.24 51.52L176.28 39.48H159.25V26.33H176.28L164.24 14.29L173.54 4.99L185.58 17.03V0H198.73V17.03L210.77 4.99L220.07 14.29L208.03 26.33H225.06V39.48Z"
      fill="white"
    />
  </svg>
);

VigilWhiteLogo.propTypes = {
  width: number,
  height: number,
  member: object,
};

export default VigilWhiteLogo;
